export default __webpack_public_path__ + "static/Entenda0011-f42d4f9fb5eb563bcd1aeac03989738b.jpg";